export const hasRedactedInformation = (valueToTestAgainst) => {
  return !!(valueToTestAgainst && valueToTestAgainst.indexOf('REDACTED (Amazon)') >= 0);
};

export const redactPIIFromAddress = (address) => {
  return {
    ...address,
    name: undefined,
    line1: undefined,
    line2: undefined,
    line3: undefined,
    phone: undefined,
  };
};

export const redactPIIFromShippingConfiguration = (shippingConfiguration) => {
  const originalShipTo = shippingConfiguration?.shipTo;

  return originalShipTo
    ? {
        ...shippingConfiguration,
        shipTo: redactPIIFromAddress(originalShipTo),
      }
    : shippingConfiguration;
};
